import React, { Component } from 'react';
import lang from '../lang/index';
import url from 'c-url';
import Contact from './contact';

class VerifyFail extends Component {

    render() {
        const fea = url.query('feature');
        const isHujing = fea == 224;
        const isUpVoice = fea == 226;
        let tip = lang.template("请返回Up直播中重新进行邮箱验证");
        if (isHujing) {
            tip = lang.template("请返回虎鲸直播中重新进行邮箱验证");
        } else if (isUpVoice) {
            tip = lang.template("请返回UpVoice中重新进行邮箱验证");
        }
        let appName = url.query('appname') || null;
        return (
            <div>
                {appName ? null : <div className={isHujing ? 'hujing-logo' : 'logo'}></div>}
                <div className="verify-result">
                    <div className={isHujing ? "verifylogo fail-hj" : "verifylogo fail"}></div>
                    <div className="notice">
                        <h2>{lang.template("验证失败")}</h2>
                        <p>{lang.template("验证失败")}</p>
                        <p>{tip}</p>
                    </div>
                </div>
                <Contact />
            </div>
        );
    }

}

export default VerifyFail;



// WEBPACK FOOTER //
// ./js/view/verify-fail.js